
  import { mapState } from 'vuex'
  import moment from 'moment'
  // import lottie from '../../components/global/lottie.vue'
  // import animationData from '~/assets/data/lottie/bo-add-to-bag.json'

  export default {
    head() {
      return this.$metadata(this.story)
    },
    data() {
      return {
        added: false,
        plus: false,
        story: {},
        product: null,
        quantity: 1,
        activeModifier: null,
        cost: 0,
        modifiers: [],
        height: 0,
        loading: false,
        cartMsg: 'Add to Cart',
        showAvailabilityModal: false,
        // eventData: {},
        // defaultOptions: { animationData, loop: false },
        // showUpsell: false,
        showQuantityPopup: false,
      }
    },
    async mounted() {
      if (!this.location) {
        this.$router.push('/locations')
        return
      }
      if (!this.$route.query.id) {
        this.$router.push('/order')
        return
      }

      this.product = await this.$api.getProduct(this.$route.query.id)
      if (!this.product) {
        this.$router.push('/order')
        return
      }

      this.setProduct()
      // console.log(this.product)
      if (!this.product?.cost) {
        this.product.cost = 0; // Set a default value if the cost is undefined
      }
      setTimeout(() => {
        this.updateCost(); // Update the cost after loading the product
      }, 2000);

      const itemEventData = this.getEventData(this.product)
      if (itemEventData) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          'event': 'select_item',
          ...itemEventData
        })
        window.dataLayer.push({
          event: 'view_item',
          ...itemEventData
        })
      }

      // // Move recaptcha badge so it doesn't cover buttons
      // if (this.mobile) {
      //   document.querySelector('.grecaptcha-badge').style.bottom = '190px'
      // } else {
      //   document.querySelector('.grecaptcha-badge').style.bottom = '100px'
      // }

      if (this.cartId) {
        this.cartMsg = 'Update Bag'
        this.quantity = parseInt(this.$route.query.q)
        // console.log(this.product)
      }
    },
    // beforeDestroy() {
    //   document.querySelector('.grecaptcha-badge').style.bottom = '14px'
    // },
    async asyncData({ $storyapi, $api, store, query }) {
      try {
        const data = await $storyapi
          .get(`cdn/stories/order/product`, {
            version: process.env.SB_VERSION,
          })
          .then(async ({ data }) => {
            try {
              return { story: data.story, product }
            } catch (error) {
              return { story: data.story }
            }
          })
        return {
          story: data.story,
        }
      } catch (error) {
        console.error(error)
      }
    },
    computed: {
      ...mapState(['location','order','errors', 'channel', 'menu']),
      isCatering() {
        return (
          this.channel === 'catering' || window.location.href.includes('catering')
        )
      },
      mobile() {
        return (this.$mq == 'sm' || this.$mq == 'md')
      },
      cartId() {
        return this.$route.query.cid
      },
      image() {
        let source = ''
        if (this.product?.images) {
          this.product.images.forEach((image, i) => {
            if (i == 0) {
              if (process.env.GW_ENV === 'stage' || process.env.GW_ENV === 'prod') {
                source = '//olo-images-live.imgix.net/'+image.filename
              } else {
                source = '//olo-images-sandbox.imgix.net/'+image.filename
              }
            }
          })
        }
        return source
      },
      calories() {
        if (this.product?.calories) {
          if (this.product.calories.base && this.product.calories.max) {
            return this.product.calories.base+'-'+this.product.calories.max+' Cal'
          } else if (this.product.calories.base) {
            return this.product.calories.base+' Cal'
          } else if (this.product.calories.max) {
            return this.product.calories.max+' Cal'
          }
        }
      },
      modifiersSelected() {
        let selected = false
        this.modifiers.forEach(mod => {
          if (mod.options) {
            mod.options.forEach(opt => {
              if (opt.selected) {
                selected = true
              }
              if (opt.modifiers) {
                mod.options.forEach(subopt => {
                  if (subopt.selected) {
                    selected = true
                  }
                })
              }
            })
          }
        })
        return selected
      },
    },
    methods: {
      availability(item) {
        let description = ''
        if (item.availability?.description) {
          description = item.availability.description
        }
        let dayWanted = moment().format('dddd')
        if (this.order && this.order.time.wanted) {
          dayWanted = moment(this.order.time.wanted, 'YYYYMMDD HH:mm').format('dddd')
        }
        const parts = description.split(',')
        for (let i = 0; i < parts.length; i++) {
          const part = parts[i]
          if (part.includes(dayWanted)) {
            description = part.trim()
            break
          }
        }
        return description
      },
      async setProduct() {
        if (this.$route.query.id) {
          if (this.location) {
            const mods = this.product?.modifiers || []
            this.modifiers = this.setDefaults(mods)
            if (mods[0] !== undefined) {
              this.activeModifier = mods[0].id
            }
            this.updateCost()
          } else {
            this.$router.push('/locations')
          }
        } else {
          this.$router.push('/order')
        }
      },
      setDefaults(modifiers) {
        const mods = JSON.parse(JSON.stringify(modifiers))
        mods.map((m) => {
          m.options.map((o) => {
            if (this.cartId) {
              const option = this.getCartOption(o.id)
              if (option) {
                o.selected = option.quantity
              }
            } else if (o.default) {
              o.selected = true
            }
            if (o.modifiers) {
              o.modifiers = this.setDefaults(o.modifiers)
            }
          })
        })
        return mods
      },
      getCartOption(oid) {
        let option = null
        if (this.order) {
          this.order.products.map((p) => {
            if (p.id == this.cartId) {
              p.choices.map((c) => {
                if (oid == c.option_id) {
                  option = c
                }
              })
            }
          })
        }
        return option
      },
      // async setProduct() {
      //   if(this.$route.query.id) {
      //     if (this.location) {
      //       this.product = await this.$api.getProduct(this.$route.query.id)
      //       this.modifiers = this.setDefaults(this.product.modifiers)
      //       if (this.product.modifiers[0] !== undefined) {
      //         this.activeModifier = this.product.modifiers[0].id
      //       }
      //       this.updateCost()
      //     } else {
      //       this.$router.push('/menu/items/'+this.$route.query.id)
      //     }
      //   } else {
      //     this.$router.push('/order')
      //   }
      // },
      setDefaults(modifiers) {
        const mods = JSON.parse(JSON.stringify(modifiers))
        mods.map((m) => {
          m.options.map((o) => {
            if (this.cartId) {
              const option = this.getCartOption(o.id)
              if (option) {

                o.selected = option.quantity
              }
            } else if (o.default) {
              o.selected = true
            }
            if (o.modifiers) {
              o.modifiers = this.setDefaults(o.modifiers)
            }
          })
        })
        return mods
      },
      decreaseQuantity() {
        if ((this.quantity > this.product.quantities.min) && this.quantity !== 1) {
          this.quantity -= this.product.quantities.increments
            ? this.product.quantities.increments
            : 1
        }
        // console.log("Quantity decreased:", this.quantity); // Debugging output
        this.updateCost()
      },
      increaseQuantity() {
        // Check limit quantity first
        if (this.product.limit_quantity) {
          if (parseInt(this.quantity) >= parseInt(this.product.limit_quantity)) {
            this.showQuantityPopup = true
            return
          }
        }
        
        if (
          !this.product.quantities.max ||
          this.quantity < this.product.quantities.max
        ) {
          this.quantity += this.product.quantities.increments
            ? this.product.quantities.increments
            : 1
        }
        // console.log("Quantity increased:", this.quantity); // Debugging output
        this.updateCost()
      },
      findModAndOption(modifiers, mid, id) {
        for (const m of modifiers) {
          if (m.id == mid) {
            const option = m.options.find(o => o.id == id)
            if (option) return { modifier: m, option }
          }
          for (const o of m.options) {
            if (o.modifiers) {
              const result = this.findModAndOption(o.modifiers, mid, id)
              if (result.modifier) return result
            }
          }
        }
        return { modifier: null, option: null }
      },
      addModifier(mid, id, q) {
        const modifiers = JSON.parse(JSON.stringify(this.modifiers))
        this.modifiers = this.activateModifier(modifiers, mid, id, q)
        this.updateCost()
        const { modifier, option } = this.findModAndOption(this.modifiers, mid, id)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'customize_item',
          item_id: this.product?.id?.toString() || this.product?.sku?.toString(),
          customization_type: modifier?.description || modifier?.name,
          customization_value: option?.name,
          action: q > 0 ? 'add' : 'remove',
          price_change: option?.cost || 0,
          location_name: this.$store.state.location?.name,
          location_code: this.$store.state.location?.id
        })
      },
      setActiveMod(mod) {
        this.activeModifier = mod
      },
      activateModifier(modifiers, mid, id, q) {
        modifiers.map((m) => {
          if (m.id == mid) {
            const s = m.selects
            m.options.map((o) => {
              if (s.mandatory && !s.min && !s.max) {
                if (o.id == id) {
                  o.selected = true
                } else {
                  o.selected = false
                }
              } else if (o.id == id && !s.min && !s.max) {
                o.selected = !o.selected
              } else if (o.id == id) {
                let totals = 0
                m.options.map((p) => {
                  if (p.selected) {
                    totals += p.selected
                  }
                })
                if (totals < s.max && q > 0 || q < 0) {
                  if (!o.selected) {
                    if (q != -1) {
                      o.selected = 1
                    }
                  } else {
                    if (q !== 1 || o.quantities.max !== totals) {
                      o.selected += q
                    }
                  }
                }
              }
            })
          }
          m.options.map((o) => {
            if (o.modifiers) {
              o.modifiers = this.activateModifier(o.modifiers, mid, id, q)
            }
          })
        })
        return modifiers
      },
      updateCost() {
        // Multiply the base cost of the product by the current quantity
        const baseCost = this.product.cost * this.quantity;
        // console.log("Base cost with quantity:", baseCost); // Debugging output

        // Get the cost with modifiers included
        this.cost = this.getModifierCost(baseCost, this.modifiers);
        // console.log("Total updated cost:", this.cost); // Debugging output
      },
      getModifierCost(cost, mods) {
        mods.map((m) => {
          m.options.map((o) => {
            if (o.selected) {
              // Add the cost of each selected modifier to the base cost
              cost += o.cost * o.selected;
              // console.log(`Added ${o.cost} for modifier ${o.name} * quantity ${o.selected}`); // Debugging output

              // Recursively calculate the cost for any sub-modifiers
              if (o.modifiers) {
                cost = this.getModifierCost(cost, o.modifiers);
              }
            }
          });
        });
        return cost;
      },
      isAvailable() {
        try {
          if (this.product.availability && this.product.availability.description) { // may be available, check time
            let str = this.product.availability.description
            let first = str.split(':')[0].substr(str.split(':')[0].length - 2).replace(' ','')
            let last = str.split(':')[1].substr(0, 4).replace(' ','')
            let from = moment(first + ':' + last,'h:mma')
            let isAvailable = (moment().isAfter(from))
            return isAvailable
          } else { // is available always
            return true
          }
        } catch(err) {
          return true
        }
      },
      getEventData(item) {
        if (!item || (item.id == null && item.name == null)) {
          return null
        }

        const eventItem = {
          'item_id': item.id,
          'item_name': item.name,
          'price': this.cost,
          'quantity': this.quantity,
        }

        const category = this.menu?.categories?.find(c => c.products.find(p => p.name === eventItem.item_name))
        if (category) {
          eventItem.item_list_id = category.id
          eventItem.item_list_name = category.name
          eventItem.item_category = category.name
        }

        if (this.$route.query?.bo_favorites) {
          eventItem.item_list_id = 'bo_favorites'
          eventItem.item_list_name = 'Bos Favorites'
          eventItem.index = this.$route.query.bo_favorites
          eventItem.item_category = 'Bos Favorites'
        }

        return {
          'ecommerce': {
            'affiliation': this.channel,
            'items': [eventItem],
            'currency': 'USD',
            'item_list_id': eventItem.item_list_id,
            'item_list_name': eventItem.item_list_name,
            'item_category': eventItem.item_category,
            'location_name': this.location?.name,
            'location_code': this.location?.id,
            'price':  this.cost,
          }
        }
      },
      async addToCart(confirmed = false) {
        // Check if item is already in cart and would exceed limit
        if (this.product.limit_quantity) {
          // Find existing quantity of this item in cart
          let existingQuantity = 0
          if (this.order && this.order.products) {
            this.order.products.forEach(cartItem => {
              if (cartItem.name === this.product.name) {
                existingQuantity += cartItem.quantity
              }
            })
          }
          
          // Check if adding current quantity would exceed limit
          const totalQuantity = existingQuantity + parseInt(this.quantity)
          if (totalQuantity > parseInt(this.product.limit_quantity)) {
            this.showQuantityPopup = true
            return
          }
        }

        if (this.product.availability.description && !confirmed) {
          this.showAvailabilityModal = true
          return false
        } else {
          this.showAvailabilityModal = false
          this.loading = true
        }
        const errors = this.checkModifiers([], this.modifiers)
        if (errors.length == 0) {

          const product = {
            id: this.cartId ? this.cartId : this.product.id,
            quantity: this.quantity,
            choices: this.addChoicesToProduct([], this.modifiers),
          }

          let order = null
          if (this.cartId) {
            this.cartMsg = 'Updating bag…'
          } else {
            this.cartMsg = 'Adding to bag…'
          }

          if (this.cartId) {
            order = await this.$api.updateInOrder([product])
            if (order === null) {
              return
            } else {
              this.$router.push('/order/')
              setTimeout(() => {
              // Adding this 1-second timeout to ensure sufficient time for the cart to be displayed sequentially
              // when accessing "/order/", as requested by QA.
                this.$store.commit('setShowCart', true)
              }, 1000)
            }
          } else {
            order = await this.$api.addToOrder([product])
            if (order === null) {
              return
            } else {
              this.$router.push('/order/')
              setTimeout(() => {
              // Adding this 1-second timeout to ensure sufficient time for the cart to be displayed sequentially
              // when accessing "/order/", as requested by QA.
                this.$store.commit('setShowCart', true)
              }, 1000)
            }
          }
          if (order) {
            const addToCartData = this.getEventData(this.product)
            if (addToCartData) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                'event': 'add_to_cart',
                ...addToCartData
              })
            }
            const orderType = this.isCatering ? 'Catering' : 'Mealtime'
            this.$braze.logCustomEvent('Add_Product_To_Cart', {
              Product: this.product,
              Cart_Items: this.order.products,
              Cart_Cost: this.order.totals.total,
              Channel: orderType
            })

            this.added = true
            if (this.cartId) {
              this.cartMsg = 'Update bag'
            } else {
              this.cartMsg = 'Added to bag'
            }
            this.$store.commit('setErrors', [])
            // this.$store.commit('setShowCart', true)
            if (process.browser) {
              try {
                const bag = document.querySelector('.bag')
                bag.classList.add('bounce')
                setTimeout(function () {
                  bag.classList.remove('bounce')
                }, 700)
              } catch (err) {}
            }
          } else {
            // do something with the error
            if (this.cartId) {
              this.cartMsg = 'Update bag'
            } else {
              this.cartMsg = 'Add to bag'
            }
          }
          setTimeout(
            function () {
              this.loading = false
            }.bind(this),
            2000
          )

        } else {
          this.loading = false
          this.$store.commit('setErrors', errors)
          // show errors
          // const productInfo = document.querySelector(
          //   '.product > .shadow:last-of-type > div'
          // )
          // window.scrollTo({
          //   top: productInfo.scrollHeight,
          //   behavior: 'smooth',
          // })
          // console.log(document.querySelector('.errors'))
          this.$nextTick(() => {
            document.querySelector('.errors').scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            })
          })
        }
      },
      checkModifiers(errors, mods) {
        mods.map((m) => {
          const s = m.selects
          let selected = 0
          m.options.map((o) => {
            if (o.selected) {
              selected += o.selected
              if (o.modifiers) {
                errors = this.checkModifiers(errors, o.modifiers)
              }
            }
          })
          if (s.mandatory) {
            if (!s.min && !s.max && selected != 1) {
              // valid = false
              errors.push(`Error: No selection made for ${m.name}.`)
            } else {
              if (s.min && selected < s.min) {
                // valid = false
                errors.push(
                  `Minimum ${s.min} required for ${m.name} (you have ${selected}).`
                )
              }
              if (s.max && selected > s.max) {
                // valid = false
                errors.push(
                  `Maximum ${s.max} required for ${m.name} (you have ${selected}).`
                )
              }
            }
          } else if (s.min && selected < s.min) {
            errors.push(
              `Minimum ${s.min} required for ${m.name} (you have ${selected}).`
            )
          }
        })
        return errors
      },
      addChoicesToProduct(choices, mods) {
        mods.map((m) => {
          m.options.map((o) => {
            if (o.selected) {
              choices.push({
                id: o.id,
                quantity: typeof o.selected === 'number' ? o.selected : 1,
              })
              if (o.modifiers) {
                choices = this.addChoicesToProduct(choices, o.modifiers)
              }
            }
          })
        })
        return choices
      },
      slug(name) {
        if (name) {
          return name.split(' - ')[0].toLowerCase().replace(/ /g, '-').replace(/'/g, '').replace(/’/g, '').trim()
        }
      },
      handleAnimation(anim) {
        this.anim = anim
        this.anim.play()
        setTimeout(() => {
          this.$emit('finishedAnimation')
        }, 200)
      },
      availableString(str) {
        if (str.includes('from')) {
          let first = str.split(':')[0].substr(str.split(':')[0].length - 2).replace(' ','')
          let last = str.split(':')[1].substr(0, 4).replace(' ','')
          let from = moment(first + ':' + last,'h:mma').format('h:mm a')
          return 'This menu item is available after '+from
        } else {
          return 'This menu item is available '+str
        }
      }

    }
  }
